import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { DotsSixVerticalIcon } from '@phosphor-icons/react'

import PackagingItem from '../PackagingItem/PackagingItem'
import * as Styles from './styles'

const SortablePackagingItem = props => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props.data.id,
    disabled: !props.isEditable,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Styles.SortablePackagingItemContainer
      dragging={props.dragging}
      isSortable={props.isEditable}
      ref={setNodeRef}
      style={style}
    >
      <DotsSixVerticalIcon size={24} id="draggable-icon" data-testid="draggable-icon" {...attributes} {...listeners} />
      <PackagingItem {...props} index={props.position} />
    </Styles.SortablePackagingItemContainer>
  )
}

export default SortablePackagingItem
